var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"aliases"},_vm._l((_vm.aliases || []),function(alias){return _c('LinkCount',{key:alias,staticClass:"alias",attrs:{"bookmarkId":_vm.bookmarkId,"link":_vm.link}},[_vm._v(" "+_vm._s(alias)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }